import { createTheme } from '@mui/material/styles';

const CUCTheme = createTheme({
  components: {
    MuiInput: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: 'green',
          },
          color: 'green',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '16px',
          color: '#000',
          backgroundColor: 'white',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#15e577',
            borderColor: '#564345',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#2b39b9',
          '&.Mui-checked': {
            color: '#2b39b9',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
    button: {
      textTransform: 'none',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
    },
  },
  palette: {
    primary: {
      main: '#7BD5A7',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFFFFF',
      contrastText: '#1A56C0',
    },
  },
});

export default CUCTheme;
